import * as React from 'react';
import Select from 'react-select';
import { FilterOptionEntry } from "../context/Form";

type MultipleSelectProps = {
    options: Array<FilterOptionEntry>;
    label: string;
    value: Array<string>;
    updateSegment: (data:Array<string>) => void;
};

export const MultipleSelect = (props: MultipleSelectProps) => {

    const defaultValue = props.value ? props.value.map((value: string) =>  {
        const option = props.options.filter((item)  => {
            return item.value === value;
        });
        return {
            label: option[0].title,
            value: option[0].value
        }
    }) : [];

    const handleChange = (newValue: any) => {
        props.updateSegment(newValue.map((value) => {
            return value.value;
        }));
    }

    return <div className={'c-segments__segment__multiselect'}>
        <label htmlFor={''}>{props.label}</label>
        <Select
            key={props.value ? props.value.join(',') : ''}
            isMulti
            defaultValue={defaultValue}
            onChange={handleChange}
            options={props.options.map((value) => {
                return {
                    label: value.title,
                    value: value.value
                }
            })}/>
    </div>
}
